import { useState, useEffect } from 'react';
import { hasActionPermission } from '@tribeplatform/gql-client';
import { useAnalytics, useNetwork } from '@tribeplatform/react-sdk/hooks';
export const AnalyticsFeeder = ({ children, queries, fields }) => {
    var _a, _b;
    const [data, setData] = useState([]);
    const { data: network } = useNetwork();
    const { authorized: isSupported } = hasActionPermission((_b = (_a = network === null || network === void 0 ? void 0 : network.authMemberProps) === null || _a === void 0 ? void 0 : _a.permissions) !== null && _b !== void 0 ? _b : [], 'analytics');
    const { data: analyticsData, isLoading } = useAnalytics({
        variables: {
            queries,
        },
        ...(fields
            ? {
                fields,
            }
            : {}),
        useQueryOptions: {
            refetchOnMount: 'always',
            enabled: isSupported,
        },
    });
    useEffect(() => {
        if (analyticsData) {
            setData(analyticsData);
        }
    }, [analyticsData]);
    if (!isSupported) {
        return null;
    }
    return children({
        data,
        isLoading,
    });
};
//# sourceMappingURL=analyticsFeeder.js.map